export const formatCurrency = (value: string) => {
  const numericValue = value.replace(/\D/g, "");
  const number = Number(numericValue) / 100;
  return number.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

export const formatCurrency2 = (value: string) => {
  const numericValue = value.replace(/\D/g, "");
  const number = Number(numericValue);
  return number.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};
